import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Noir Elegance layout — luxury/fashion.
 * Centered content with ornamental diamond-shaped decorative lines.
 * Footer pinned at bottom for cross-template consistency.
 */
export function NoirEleganceLayout({ data, fontPreset, pc }) {
  const ornament = (
    <div className="my-8 flex items-center justify-center gap-4">
      <div className="h-[1px] flex-1" style={{ backgroundColor: pc.text(0.15) }} />
      <div className="w-3 h-3 rotate-45 border" style={{ borderColor: pc.text(0.20) }} />
      <div className="h-[1px] flex-1" style={{ backgroundColor: pc.text(0.15) }} />
    </div>
  );

  return (
    <div className="absolute inset-0">
      <NudgeableGroup groupId="content" className="absolute inset-[80px] bottom-[140px] flex flex-col justify-center">
        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            afterTitle: ornament,
            titleClass: 'text-center',
            bodyClass: 'text-center',
            mutedOpacity: 0.60,
            subtleOpacity: 0.40,
          }}
        />
      </NudgeableGroup>

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
